import React from "react";
import "../styles/imagemotion.css";
import { motion } from "framer-motion";

export default function ImageMotion({ image, height, top, left, alt }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      exit={{ opacity: 0, x: -40 }}
      className="imagemotion"
      style={{
        top: top,
        left: left,
      }}
    >
      <img src={image} height={height} alt={alt} />
    </motion.div>
  );
}
